<script setup lang="ts">
import { MMPopupDefault, MMText } from '@mm-frontend/mm-web-ui-kit';
import { FillProfileForm } from '../business/FillProfileForm';
import { ButtonPrimaryAccented, InputMasked, InputOutlined } from '~/features/ui-kit';
import { useUserStore } from '../business/useUserStore';
import type { IUserMM } from '~/entities/user'; 

const { profile, updateProfile, closeProfileFillPopup } = useUserStore();

const form = new FillProfileForm({
  name: profile.value.name,
  email: profile.value.email,
  birthDate: profile.value.birthDate,
});

const formData = form.formData;
const hasChanges = computed(() => form.hasChanges());
const isLoading = ref(false);

async function handleSubmit() {
  const isValid = form.validate();
  if (!isValid) return;

  const profile: IUserMM = {
    firstName: formData.name.value || '',
    email: formData.email.value || '',
    birthDate: formData.birthDate.value || '',
  }

  await updateProfile(profile); 
  form.reset();
  isLoading.value = true;
  closeProfileFillPopup();    
}
</script>

<template>
  <MMPopupDefault class="popup" :is-closable="false">
    <template #header>
      <MMText font="Title L/Semibold" label="Заполните свой профиль" />
    </template>

    <div class="popup-content">
      <InputOutlined
        v-model="formData.name.value"
        placeholder="Введите имя"
        label="Имя"
        is-required
        :absolute-errors="false"
        :error="formData.name.error"
      />

      <InputOutlined
        v-model="formData.email.value"
        placeholder="Введите электронную почту"
        label="Электронная почта"
        is-required
        :absolute-errors="false"
        :error="formData.email.error"
      />

      <InputMasked
        v-model="formData.birthDate.value"
        label="Дата рождения"
        placeholder="ДД-ММ-ГГГГ"
        :error="formData.birthDate.error"
        mask="00-00-0000"
        :absolute-errors="false"
      />
    </div>

    <template #footer>
      <ButtonPrimaryAccented w100 size="l48" :disabled="!hasChanges" :loading="isLoading" @click="handleSubmit">
        Сохранить
      </ButtonPrimaryAccented>
    </template>
  </MMPopupDefault>
</template>

<style scoped lang="stylus">
.popup
  width 480px

  +Media(Mobile)
    max-width calc(100vw - 32px)

  &-content
    height 100%
    margin-top 16px
    margin-bottom 24px
    display flex
    flex-direction column
    gap 16px
</style>